var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{key:"flag",class:_vm.flagClass,attrs:{"aria-label":`The ${_vm.code.toUpperCase()} flag`}})
}
var staticRenderFns = []

export { render, staticRenderFns }